export enum BenchmarkIconEnum {
  mena = 'fa-earth-africa',
  country = 'fa-flag',
  industry = 'fa-industry',
  previous = 'fa-clock',
  topPerformer = 'fa-star'
}